import React, {useState} from "react";
import { Button } from "@allxsmith/bestax-bulma";
import useEditableTableDateCell from "../../hooks/useEditableTableDateCell";
import useEditableTableCostCell from "../../hooks/useEditableTableCostCell";
import useEditableTableTextCell from "../../hooks/useEditableTableTextCell";
import useEditableTableTextAreaCell from "../../hooks/useEditableTableTextAreaCell";
import NominalCodePicker from "../Settings/NominalCodes/NominalCodePicker";


export default function InvoiceCreditRow({data, onChange, onSave, onDelete, onReady, onApprove, index, nominalCodes, onNominalChange}){
    const [editable, setEditable] = useState(false);

    const handleSave = () => {
        onSave(data);
        setEditable(false);
    }

    return (
        <tr key={data.id}>
            <td>{data.invoice ? data.invoice.id : ""}</td>
            <td>{data.invoice ? data.invoice.description : ""}</td>
            {useEditableTableTextAreaCell({
                propName: "description",
                value: data.description,
                onSave: handleSave,
                onChange: (e) => onChange(e, index),
                editable,
                setEditable,
                inlineEdit: true,
                disabled: data.approved
            })}
            <td>{data.invoice ? data.invoice.customer.display_name : ""}</td>
            <td>
                <NominalCodePicker
                    options={nominalCodes}
                    value={data.vat_nominal_code}
                    onChange={(e) => onNominalChange(e, index)}
                    onSave={handleSave}
                    name={"vat_nominal_code"}
                    editable={editable}
                    setEditable={setEditable}
                    blank={true}
                    disabled={data.approved || !editable}
                    inlineEdit={!data.approved}
                />
            </td>
            <td>
                <NominalCodePicker
                    options={nominalCodes}
                    value={data.no_vat_nominal_code}
                    onChange={(e) => onNominalChange(e, index)}
                    onSave={handleSave}
                    name={"no_vat_nominal_code"}
                    editable={editable}
                    setEditable={setEditable}
                    blank={true}
                    disabled={data.approved || !editable}
                    inlineEdit={!data.approved}
                />
            </td>
            {useEditableTableTextCell({
                propName: "credit_note_number",
                value: data.credit_note_number,
                onChange: (e) => onChange(e, index),
                onSave: handleSave,
                editable,
                setEditable,
                inlineEdit: true,
                disabled: data.approved
            })}
            {useEditableTableDateCell({
                propName: "date_issued",
                value: data.date_issued,
                onChange: (e) => onChange(e, index),
                onSave: handleSave,
                editable,
                setEditable,
                inlineEdit: true,
                disabled: data.approved
            })}
            {useEditableTableCostCell({
                propName: "amount",
                value: data.amount,
                onChange: (e) => onChange(e, index),
                onSave: handleSave,
                editable,
                setEditable,
                inlineEdit: true,
                disabled: data.approved
            })}
            {useEditableTableCostCell({
                propName: "no_vat_amount",
                value: data.no_vat_amount,
                onChange: (e) => onChange(e, index),
                onSave: handleSave,
                editable,
                setEditable,
                inlineEdit: true,
                disabled: data.approved
            })}
            {!data.ready_to_approve &&
                <td>
                    <Button
                        color={"info"}
                        onClick={() => onReady(data)}
                    >
                        O
                    </Button>
                </td>
            }
            {data.ready_to_approve && !data.approved &&
                <td>
                    <Button
                        color={"success"}
                        onClick={() => onApprove(data)}
                    >
                        O
                    </Button>
                </td>
            }
            <td>
                <Button
                    color={"danger"}
                    onClick={() => onDelete(data)}
                    disabled={data.approved}
                >
                    X
                </Button>
            </td>
        </tr>
    )



}